import React from 'react';

import { FieldValues } from 'react-hook-form';

import { OhsFormSettings } from 'global-components/form/services/OhsFormModels';
import OhsSelectField from 'global-components/form/fields/OhsSelectField';

interface Props {
  id: string;
  ohsFormSettings: OhsFormSettings<FieldValues>;
  options: { name: string; value: string }[];
  required?: boolean;
}
function OhsSortFilter(props: Props) {
  return (
    <div>
      <OhsSelectField
        title="Sort"
        id={props.id}
        required={props.required ?? false}
        options={props.options}
        ohsFormSettings={props.ohsFormSettings}
      />
    </div>
  );
}
OhsSortFilter.defaultProps = {
  required: false,
};

export default OhsSortFilter;
